<template>
    <div>
      <van-nav-bar
        title="充值指南"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/member/members')"
      />
      <div>
        <div>
        <div style="overflow: auto; padding-bottom: 38px;">
          <!--<img :src="content" style="width:100%"/>-->
          <pinch-zoom>
            <div v-html="content" class="content" style="width:100%"></div>
          </pinch-zoom>

        </div>
        <div>
         <van-button type="danger" block @click="redirect" style="position:fixed; bottom: 50px;">立即充值</van-button>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
    export default {
      name: "PopupContent",
      data(){
        return{
          content:''
        }
      },
      methods:{
         redirect(){
           this.$router.push('/member/recharge')
        },
        getActivityDetail(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'sysconfig',
                'name': that.$route.query.activityid
              }
            })
            .then(ret => {
              let resData = ret.data;
              // console.log(resData);
              if (resData.code === 1){
                that.content = resData.data;
              }else{
                that.$toast.fail(resData.msg);
              }
            });
        }
      },
      mounted: function () {
        let that = this;
        this.getActivityDetail();
      },
    }
</script>

<style scoped>
  .content{
    width: 100%;
  }
  .content>>>img{
    width: 100%;
  }
  .content>>>p{
    margin: 0;
    display:grid;
  }
  .container .btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #555;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}
  .container {
    width: 100%;
   position: relative;

   /* max-width: 1200px;
  max-height: 250px;
    min-width: 1000px;
    margin: 10px auto;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/PopupContent.vue